module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAPpJREFUWEftls0NwjAMhb/CDjAOSDAC4sAkHDhyYBIOiBE4wDgwBEFBbRWVJrHDT4SUnqrW9nt+fa5TGWOGZLyqQqAoUBSIKDAAFsAVuCindQKMgSNw9+XGxnAJ7OvkDbATklgD2zp2BRxSCUyBk5MsIeGC29RZSL2YArZAt2CIhCb22ZeEgJSEGlxDIEYiCVxLwEfCPm8MZ+8lPmltJf0Erom73brvVOApCjRgfSTU4H9LIOsn6HP7z0wYGrWvj6EEQBLzshIkY6gprIkV/Yo/sYzmwDl1G2Zfx82B5BbqwtOdVW/07oFEeP5ID5OYML26ILMQKApkV+ABs8OeIah0ZbAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_off_deep.png
// module id = OLq7
// module chunks = 1